module.exports = __webpack_public_path__ + "img/gnu_main2.20344e09.jpg";